// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__14weA","content":"LayoutSettings_content__29qoa"};